const triggerHtml5FormValidation = require("../form/triggerHtml5FormValidation");
const disableSubmitButtonInForm = require("../form/disableSubmitButtonInForm");
const getFormDataAsRoiFormData = require("./getFormDataAsRoiFormData");
const submitRoiGateFormData = require("./submitRoiGateFormData");

/**
 * @param form {HTMLFormElement}
 * @return {Promise<RoiGateFormData|undefined>}
 */
module.exports = async function submitRoiGateForm(form) {
    const valid = triggerHtml5FormValidation(form);

    if (valid) {
        disableSubmitButtonInForm(form);

        const roiGateFormData = getFormDataAsRoiFormData(form);

        try {
            await submitRoiGateFormData(roiGateFormData);
        } catch (e) {
            alert("Cannot submit form");
        }

        return roiGateFormData;
    }
}